import { useRtoasterRecommendWithCache } from "@/hooks";
import RtRecommendSlider from "@/components/Rtoaster/RtRecommendSlider";
import config from "@/lib/config";
/**
 * WatchRecommend.
 *
 * watchページ用のRtoasterレコメンド
 *
 * @returns {React.ReactElement}
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function WatchRecommend() {
  const elementIds = [config.rtoasterElementId.watch.related, config.rtoasterElementId.watch.recommend];
  const {
    loading
  } = useRtoasterRecommendWithCache(elementIds);
  if (loading) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RtRecommendSlider, {
      header: {
        text: "関連作品"
      },
      elementId: config.rtoasterElementId.watch.related
    }), /*#__PURE__*/_jsx(RtRecommendSlider, {
      header: {
        text: "あなたにおすすめの作品"
      },
      elementId: config.rtoasterElementId.watch.recommend
    })]
  });
}